export default __webpack_public_path__ + "static/media/2.ff167c23.jpg";